import React, { useState } from "react";
import axios from "axios";
import { Button, Modal, TextInput } from "@opendate-app/setlist";

import { toastSuccess, toastError } from "../../../shared/toastHelper";

export const sendTestErrorMessage = (error) => (
  error.response?.data?.error || "Could not send test SMS, please try again"
);

// The server distinguishes a real send from a simulated one in non-live
// environments, so prefer its message over assuming anything was delivered.
export const sendTestSuccessMessage = (response) => (
  response?.data?.message || "Test SMS sent successfully"
);

const SendTestOverlay = ({
  templatableContext,
}) => {
  const {
    csrfToken,
    testModalOpen,
    setTestModalOpen,
    template,
    sampleData,
    twilioTemplate,
    team,
  } = templatableContext();

  const [testInputValue, setTestInputValue] = useState("");

  const sendTest = () => {
    if (!testModalOpen || !testInputValue) { return; }

    const phoneNumbers = testInputValue.split(",").map((phoneNumber) => phoneNumber.trim());
    const invalidPhoneNumbers = phoneNumbers.filter((phoneNumber) => !phoneNumber.match(/^\+1\d{10}$/));

    if (invalidPhoneNumbers.length > 0) {
      toastError(`Phone numbers must be in +1xxxxxxxxxx format: ${invalidPhoneNumbers.join(", ")}`);
      return;
    }

    setTestModalOpen(false);
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    axios.post(`/teams/${team.id}/twilio_templates/${twilioTemplate.id}/test`, {
      phone_numbers: testInputValue,
      template: template,
      liquid_data: sampleData,
    })
      .then((response) => {
        toastSuccess(sendTestSuccessMessage(response));
      })
      .catch((error) => {
        toastError(sendTestErrorMessage(error));
      });
  };

  const close = () => setTestModalOpen(false);

  return (
    <Modal
      open={testModalOpen}
      onClose={close}
      title="Test SMS"
      description="Send a test SMS to..."
      footer={(
        <>
          <Button variant="secondary" onClick={close}>Cancel</Button>
          <Button variant="primary" disabled={!testInputValue} onClick={sendTest}>
            Send Test
          </Button>
        </>
      )}
    >
      <TextInput
        aria-label="Test SMS recipients"
        placeholder="Example: +12223334444, +13334445555"
        value={testInputValue}
        onChange={(e) => setTestInputValue(e.target.value)}
      />
    </Modal>
  );
};

export default SendTestOverlay;
